import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedService } from '../Shared/Services/shared.service';
import { environment } from '../../environments/environment'

@Injectable({
    providedIn: 'root'
})
export class OrdersService {
    readonly APIurl = environment.apiUrl;
    constructor(private http: HttpClient, private shared: SharedService) { }

    GetParenrCategorywithProduct() {
        return this.http.get(`${this.APIurl}/Category/GetParenrCategorywithProduct`, this.shared.options);
    }

    AddNewInvoices(invoice: any) {
        return this.http.post(`${this.APIurl}/Invoice/AddNewInvoices`, invoice, this.shared.options);
    }

    AddInvoicesDetails(invoiceId: any, product: any) {
        return this.http.post(`${this.APIurl}/Invoice/AddInvoicesDetails?invoiceId=${invoiceId}`, product, this.shared.options);
    }

    GetAllInvoicesFromAgentOrWorkShop(isRecived: any) {
        return this.http.get(`${this.APIurl}/Invoice/GetAllInvoicesFromAgentOrWorkShop?isRecived=${isRecived}`, this.shared.options);
    }

    DeleteInvoices(invoiceIds: any) {
        return this.http.post(`${this.APIurl}/Invoice/DeleteInvoices?ids=${invoiceIds}`, null, this.shared.options);
    }

    GetMaxNumberIncoices() {
        return this.http.get(`${this.APIurl}/Invoice/GetMaxNumberIncoices`, this.shared.options);
    }
}
